import React, { useState, useEffect } from 'react';
import { maintenanceService } from '../Services/maintenanceService';
import { AlertTriangle } from 'lucide-react';

const MaintenanceBanner = () => {
  const [maintenanceStatus, setMaintenanceStatus] = useState(null);

  useEffect(() => {
    maintenanceService.getMaintenanceStatus().then((status) => {
      setMaintenanceStatus(status);
    });

    const unsubscribe = maintenanceService.subscribeToMaintenanceStatus((status) => {
      setMaintenanceStatus(status);
    });

    return () => unsubscribe();
  }, []);

  // Gérer le padding du body pour éviter le chevauchement
  useEffect(() => {
    if (maintenanceStatus && !maintenanceStatus.aiServicesEnabled) {
      document.body.classList.add('has-maintenance-banner');
    } else {
      document.body.classList.remove('has-maintenance-banner');
    }

    return () => {
      document.body.classList.remove('has-maintenance-banner');
    };
  }, [maintenanceStatus]);

  if (!maintenanceStatus || maintenanceStatus.aiServicesEnabled) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-red-600 to-orange-600 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-center gap-3 text-center">
          <AlertTriangle className="w-5 h-5 flex-shrink-0 animate-pulse" />
          <div>
            <p className="font-bold text-sm md:text-base">
              🚨 MAINTENANCE EN COURS
            </p>
            <p className="text-xs md:text-sm opacity-90">
              Les services IA (chat médical, analyse de sang) sont temporairement indisponibles.
              {maintenanceStatus.reason && ` ${maintenanceStatus.reason}`}
            </p>
          </div>
          <AlertTriangle className="w-5 h-5 flex-shrink-0 animate-pulse" />
        </div>
      </div>
    </div>
  );
};

export default MaintenanceBanner;
